import { reactive, toRefs } from 'vue'

import type { ChatEvent } from '~/api/shopping-assistant/types'

function createDefaults() {
  return {
    inputText: '',
    events: [] as ChatEvent[],
    isLoading: true,
    isProcessing: false,
    chatNotFoundError: false,
    chatId: null as string | null,
    streamedMessage: '',
  }
}

export function useShoppingAssistantState(initialChatId: string | null) {
  const state = reactive({ ...createDefaults(), chatId: initialChatId })

  function resetState() {
    Object.assign(state, createDefaults())
  }

  return {
    ...toRefs(state),
    resetState,
  }
}
